import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = []

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    next(`/${process.env.VUE_APP_HOME}`)
  } else {
    next()
  }
})

export default router
